import React, { Component } from 'react';
import Picker from 'pickerjs';
import Moment from 'moment';
import ProgressBar from '../../shared/progress_bar';
import './Date.scss';

class DateComponent extends Component {

  constructor(props){ 
    super(props);
    this.state = {
      selectedAnswer: ""
    }
    this.pushSelectedAnswer = this.pushSelectedAnswer.bind(this);
    this.handleDatepicker = this.handleDatepicker.bind(this);
  }
  
  componentDidMount() {
    this.handleDatepicker(document.querySelector(".js-inline-picker"));
  }

  handleDatepicker(selector) {
      const datepickerElement = selector;
      let picker;

      if ( datepickerElement ) {
          picker = new Picker(datepickerElement, {
              format: "MMMM-DD-YYYY",
              inline: true,
              months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
          });
      }

      picker.pick();
      this.setState({selectedAnswer: picker.date});
  }

  pushSelectedAnswer() {
    const formatDate = Moment(this.state.selectedAnswer).format('yyyy-MM-DD hh:mm:ss')
    this.props.next(formatDate);
  }


  render() {
    return (
        <div className="page__container" action="#">
            <div className="page__top-wrapper">
                <div className="page__text">
                  <h1>{this.props.actualQuestion.title}</h1>
                  <p className="page__desc">{this.props.actualQuestion?.description}</p>
                </div>
                <ProgressBar questions={this.props.questions} actualQuestion={this.props.actualQuestion} type="dark"/>
            </div>

            <div className="js-inline-picker">Abril 23 2020</div>

            <button 
              onClick={this.pushSelectedAnswer}
              className="text-input__main-button main-button main-button--colored" type="submit">
                <span className="main-button__label">Continuar</span>
                <svg className="main-button__icon" width="25" height="25">
                    <use xlinkHref="/images/sprite.svg#arrow_down"></use>
                </svg>
            </button>
        </div>
    );
  }

}

export default DateComponent;
